<!--The content below is only a placeholder and can be replaced.-->
<!-- <mat-toolbar> My App</mat-toolbar> -->

<link *ngIf="this.flagOHC" rel="stylesheet" [href]="sanitizer.bypassSecurityTrustResourceUrl(scssUrl)">


<!-- TOOLBAR -->
<mat-toolbar class="mat-toolbar mat-elevation-z6"> 
    <mat-toolbar-row >
      <button class="signOut" *ngIf="(flagGroup)" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
      <img width="50" src="./../assets/imagenes/icono2.png">
      <span>Amicare - {{this.nombre}}</span>
      <div class="spacer"></div>
      <button class="signOut" *ngIf="(!flagLogKeyCloak)" (click)="signOut()">
        <mat-icon>exit_to_app</mat-icon>
    </button >
    <dash-button *ngIf="(flagLogKeyCloak)" client-id="dash-button" realm="ecosystem-hub" keycloak-url="https://pharaon-dev-idp.eng.it"></dash-button>
    </mat-toolbar-row> 
  </mat-toolbar>
  
  <mat-tab-group mat-stretch-tabs class="mat-tab-group">
    <mat-tab label="Estado">
      <app-tab-actual class="tab" [arrayUser]="this.arrayUser"></app-tab-actual>
     </mat-tab>
    <mat-tab label="Ambiente">
       <app-tab-datos class="tab" [arrayUser]="this.arrayUser"></app-tab-datos>
      </mat-tab>
    <mat-tab label="Actividad">
       <app-tab-eventos class="tab" [arrayUser]="this.arrayUser"></app-tab-eventos>
      </mat-tab>
    <mat-tab *ngIf="(flagGroup)" label="Alarmas">
       <app-tab-alarmas  class="tab" [arrayUser]="this.arrayUser"></app-tab-alarmas>
      </mat-tab>
  </mat-tab-group>
  
   
  <footer class="footer mat-elevation-z4">
      <img class="imagencetem " src="./../assets/imagenes/developed_by_cetem.png"/>
      &copy;
  </footer>
  
